<template>
  <div class="h-auto ml-0 w-full lg:mr-3 mt-2 p-3 pt-0">
    <separation-type-list />
  </div>
</template>

<script>
import SeparationTypeList from "@/components/CompanySetups/separation/separationTypeList";

export default {
  name: "SeparationTabs",
  props: ["updateLeaveList", "setup"],
  components: {
    SeparationTypeList,

  },
  data() {
    return {
      isApproved: true,
      isDeclined: false,
    };
  },
  created() {},
  methods: {
    close() {
      this.$emit("close");
    },
  },
  watch: {},
};
</script>
<style>
.el-tabs--border-card > .el-tabs__content {
  padding: 0;
}
</style>
